import { TableColumn } from '@shared/components/data-table/data-table.component';

export const STOCK_HOLD_TIMEOUT_DEFAULT_COLUMNS = {
  HOLD_CATEGORY: 'holdCategory',
  TIMEOUT_MINUTES: 'timeoutMinutes',
  TIMEOUT_DISPLAY: 'timeoutDisplay',
  ENABLED: 'enabled',
} as const;

export const STOCK_HOLD_TIMEOUT_ACTION_COLUMN = {
  ACTIONS: 'actions',
} as const;

export const STOCK_HOLD_TIMEOUT_DEFAULT_COLUMNS_ORDER: string[] = [
  STOCK_HOLD_TIMEOUT_DEFAULT_COLUMNS.HOLD_CATEGORY,
  STOCK_HOLD_TIMEOUT_DEFAULT_COLUMNS.TIMEOUT_DISPLAY,
  STOCK_HOLD_TIMEOUT_DEFAULT_COLUMNS.ENABLED,
];

export const STOCK_HOLD_TIMEOUT_FLEXIBLE_COLUMNS_ORDER: string[] = [
  STOCK_HOLD_TIMEOUT_DEFAULT_COLUMNS.TIMEOUT_MINUTES,
];

export const STOCK_HOLD_TIMEOUT_COLUMNS: TableColumn[] = [
  {
    label: 'stock_hold_timeout.table.hold_category',
    prop: STOCK_HOLD_TIMEOUT_DEFAULT_COLUMNS.HOLD_CATEGORY,
    width: 200,
    type: 'custom',
    template: 'categoryTemplate',
  },
  {
    label: 'stock_hold_timeout.table.timeout',
    prop: STOCK_HOLD_TIMEOUT_DEFAULT_COLUMNS.TIMEOUT_DISPLAY,
    width: 140,
  },
  {
    label: 'stock_hold_timeout.table.timeout_minutes',
    prop: STOCK_HOLD_TIMEOUT_DEFAULT_COLUMNS.TIMEOUT_MINUTES,
    width: 120,
    type: 'number',
  },
  {
    label: 'stock_hold_timeout.table.status',
    prop: STOCK_HOLD_TIMEOUT_DEFAULT_COLUMNS.ENABLED,
    width: 120,
    type: 'status',
  },
  {
    label: 'stock_hold_timeout.table.actions',
    prop: STOCK_HOLD_TIMEOUT_ACTION_COLUMN.ACTIONS,
    type: 'actions',
    width: 220,
  },
];
